import { useMemo } from "react";
import { SearchableSelect, type SearchableSelectOption } from "./SearchableSelect";

const SAMPLE_FILTERS = [
  { id: "factory", label: "Factory" },
  { id: "imported", label: "Imported" },
] as const;

export type SamplerSampleOption = {
  id: string;
  name: string;
};

type SamplerSampleSelectProps = {
  value: string;
  factory: readonly SamplerSampleOption[];
  imported: readonly SamplerSampleOption[];
  onChange: (sampleId: string) => void;
  onOpen?: () => void;
  className?: string;
  /** Rose ring when the assigned sample is missing from the library. */
  emphasizeMissing?: boolean;
};

/** Searchable factory / imported sample picker shared by Sampler dock + Author. */
export function SamplerSampleSelect({
  value,
  factory,
  imported,
  onChange,
  onOpen,
  className = "",
  emphasizeMissing = false,
}: SamplerSampleSelectProps) {
  const options = useMemo((): SearchableSelectOption[] => [
    ...factory.map(entry => ({
      value: entry.id,
      label: entry.name,
      group: "factory",
    })),
    ...imported.map(entry => ({
      value: entry.id,
      label: entry.name,
      group: "imported",
    })),
  ], [factory, imported]);

  return (
    <SearchableSelect
      className={[
        "min-w-0 grow basis-[8rem]",
        emphasizeMissing ? "rounded-md ring-1 ring-rose-400/60" : "",
        className,
      ].filter(Boolean).join(" ")}
      ariaLabel="Factory waveform / sample"
      searchPlaceholder="Search factory or imported samples"
      emptyMessage="No samples match."
      value={value}
      options={options}
      filters={SAMPLE_FILTERS}
      onOpen={onOpen}
      onChange={onChange}
    />
  );
}
